import { z } from 'zod';

/**
 * Which logs a report counts. `user` (the default) excludes anything derived
 * from an AI-classified ActivityEvent; `all` keeps both but prefers the
 * user-entered log whenever a check-in slot has one of each.
 */
export const logSourceFilter = z.enum(['user', 'ai', 'all']);
export type LogSourceFilter = z.infer<typeof logSourceFilter>;

export const reportQuery = z.object({
  patientId: z.uuid(),
  startDate: z.iso.datetime({ offset: true }),
  endDate: z.iso.datetime({ offset: true }),
  logSource: logSourceFilter.default('user'),
});
export type ReportQuery = z.infer<typeof reportQuery>;
